<template>
	<nav class="flex gap-2 grow text-functional-size-md">
		<MenuItem
			v-for="item in menuItems"
			:key="`menuItem-${item.to.url}`"
			:item
			@navigate="emit('navigate')"
		/>
	</nav>
</template>

<script lang="ts" setup>
import MenuItem from './MenuItem.vue';
import type { MainMenuItemType } from '#base/core/types/MainMenuItemType';

const emit = defineEmits(['navigate']);

defineProps<{
	menuItems: MainMenuItemType[];
}>();
</script>
